import React, { useState, useEffect, useRef } from "react";
import styled from "styled-components";
import ErrorBoundary from "../ErrorBoundary";
import CodeTabLabel from "./CodeTabLabel";
import hljs from "highlight.js";

const CodeTabBox = styled.blockquote`
  color: ${({ theme }) => theme.colors.gray1200};
  margin: 48px 0;
`;

const TabLabelWrapper = styled.div`
  display: flex;
`;

const TabWrapper = styled.pre`
  color: ${({ theme }) => theme.colors.gray1200};
  background-color: ${({ theme }) => theme.colors.gray300};
  font-family: ${({ theme }) => theme.fonts.atlas};
`;

const StyledCode = styled.code`
  margin: 0;
  font-size: 14px;
  line-height: 24px;
  padding: 2px 4px;
  border-radius: 2px;
  // Safety net for glitches in highlight.js, otherwise p tag content gets rendered in black color on black background.
  p {
    color: ${({ theme }) => theme.colors.white};
    font-family: ${({ theme }) => theme.fonts.atlas};
  }
`;

const CodeTabBlock = ({ tabName, tabContent }) => {
  const tabLabels = Object.keys(tabContent);
  const [activeTab, setActiveTab] = useState(
    tabLabels.length > 0 ? tabLabels[0] : "Tab"
  );
  const codeRef = useRef(null);

  useEffect(() => {
    // Even though we use hljs in the helpContent component,
    // we need to call it again here for content that is not visible on page load
    if (codeRef.current) {
      codeRef.current.innerHTML = tabContent[activeTab];
      hljs.highlightElement(codeRef.current);
    }
  });
  return (
    <ErrorBoundary>
      <CodeTabBox>
        <TabLabelWrapper>
          {tabLabels.map(label => (
            <CodeTabLabel
              key={`${tabName}-${label}`}
              isActive={label === activeTab}
              setIsActive={setActiveTab}
              label={label}
            />
          ))}
        </TabLabelWrapper>
        <TabWrapper>
          <StyledCode ref={codeRef} />
        </TabWrapper>
      </CodeTabBox>
    </ErrorBoundary>
  );
};

CodeTabBlock.defaultProps = {
  tabName: "",
  tabContent: {}
};

export default CodeTabBlock;
